module.exports = __webpack_public_path__ + "img/suggestions.1ca885fe.svg";